'use strict';

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

module.exports = (_temp2 = _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
        var _temp, _this, _ret;

        _classCallCheck(this, _class);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.modalEventListener = function (modal) {
            $(modal).on('hidden.bs.modal', function () {
                if (_this.shouldShowModal(modal)) {
                    _this.showModal(modal);
                } else {
                    _this.cleanUpModal(modal);
                }
            });
        }, _this.cleanUpModal = function (modal) {
            $(modal).modal('hide');
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');
        }, _this.showModal = function (modal) {
            console.log('showing modal - in lib');
            $(modal).modal('show');
        }, _this.shouldShowModal = function (modal) {
            return _this.props.isOpen && !_this.isModalVisible(modal);
        }, _this.isModalVisible = function (modal) {
            return $(modal).is(':visible');
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _class.prototype.componentDidMount = function componentDidMount() {
        var modal = _reactDom2.default.findDOMNode(this.refs.genericModal);
        this.modalEventListener(modal);
    };

    _class.prototype.render = function render() {
        var self = this;
        var modalDialogClasses = (0, _classnames2.default)({
            'modal-dialog': true,
            'modal-sm': this.props.size === 'small',
            'modal-md': this.props.size === 'medium',
            'modal-lg': this.props.size === 'large'
        });

        var modalClasses = (0, _classnames2.default)({
            modal: true,
            fade: !self.props.removeFade
        });
        return _react2.default.createElement(
            'div',
            {
                className: modalClasses,
                id: 'generic-modal',
                ref: 'genericModal',
                'aria-hidden': this.props.isOpen ? 'false' : 'true',
                'data-backdrop': 'static'
            },
            _react2.default.createElement(
                'div',
                { className: modalDialogClasses },
                _react2.default.createElement(
                    'div',
                    { className: 'modal-content' },
                    this.props.modalContent
                )
            )
        );
    };

    _class.prototype.componentDidUpdate = function componentDidUpdate() {
        var modal = _reactDom2.default.findDOMNode(this.refs.genericModal);
        if (this.shouldShowModal(modal)) {
            this.showModal(modal);
        } else if (!this.props.isOpen && this.isModalVisible(modal)) {
            this.cleanUpModal(modal);
        }
    };

    return _class;
}(_react2.default.Component), _class.propTypes = {
    isOpen: _propTypes2.default.bool,
    size: _propTypes2.default.oneOf(['small', 'large']),
    removeFade: _propTypes2.default.bool,
    modalContent: _propTypes2.default.node.isRequired
}, _class.defaultProps = {
    removeFade: false,
    isOpen: false
}, _temp2);


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/modal.js
// module id = 731
// module chunks = 0